export default [
    {
        path: 'fechamento-faa-massa',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-fechamento-faa-massa' */
            '@/views/pronto-atendimento/fechamento-faa-massa/Index'
        ),
        redirect: 'fechamento-faa-massa/index',
        children: [
            {
                name: 'pronto-atendimento-fechamento-faa-massa-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-fechamento-faa-massa' */
                    '@/views/pronto-atendimento/fechamento-faa-massa/List'
                ),
            },
        ],
    },
]